"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { Container, ProcessCard, SectionSubHeading } from "@/components";
import { ServiceProcess as IServiceProcess } from "@/lib/types";
import { useStackingEffect } from "@/hooks/animations/useStackingEffect";
import { useTextReveal } from "@/hooks/animations/useTextReveal";
interface ServiceProcessProps {
  process: IServiceProcess[];
}
const ServiceProcess = t0 => {
  const $ = _c(12);
  const {
    process
  } = t0;
  const sectionRef = useRef(null);
  const isDesktop = typeof window !== "undefined" && window.innerWidth >= 1024;
  useStackingEffect(sectionRef, ".desktop-card", isDesktop);
  useTextReveal(sectionRef, ".mobile-card", !isDesktop);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-muted-foreground transition-colors duration-300"><SectionSubHeading subtitle="Process" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== process) {
    t2 = process.map(_temp);
    $[1] = process;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="hidden lg:block relative w-full h-[85vh] mt-10">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== process) {
    t4 = process.map(_temp2);
    $[5] = process;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="flex flex-col gap-6 lg:hidden w-full">{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <section ref={sectionRef} className="bg-accent-foreground py-4 md:py-8 lg:py-10"><Container className="px-4 lg:px-10">{t1}{t3}{t5}</Container></section>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ServiceProcess;
function _temp(step, idx) {
  return <ProcessCard key={idx} step={step} idx={idx} className="desktop-card absolute inset-0" />;
}
function _temp2(step_0, idx_0) {
  return <ProcessCard key={idx_0} step={step_0} idx={idx_0} className="mobile-card py-4 md:py-10 mt-6 md:mt-0" />;
}